// @flow

import React, { type Node } from 'react';
import { getBoletoBarcodeRaw, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import JsBarcode from 'jsbarcode';

export function BoletoBarcode(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const barcode = getBoletoBarcodeRaw(incomingPayment);
  const src = React.useMemo(() => convertBarcodeToBase64Src(barcode), [barcode]);
  return <img src={src} alt="Código de Barras"/>;
}

function convertBarcodeToBase64Src(barcode: ?string): string {
  const canvas = document.createElement('canvas');
  const options = {
    format: 'ITF',
    displayValue: false,
    height: 100,
  };
  JsBarcode(canvas, barcode, options);
  return canvas.toDataURL('image/png');
}
